import { render } from "./DeveloperItemTable.vue?vue&type=template&id=01170f34"
import script from "./DeveloperItemTable.vue?vue&type=script&lang=js"
export * from "./DeveloperItemTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__